/* The Brand's View For Their Videos */
import { Box } from "@mui/material";
import React, { useMemo, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { SelectedVideoV2 } from "../selectedVideoCardV2";
import { MainContainer } from "../../../../components/ContentWrapper";
import { ListPageHeader } from "../../../../components/ListPageHeader/ListPageHeader";
import { MultiStepOrderModal } from "../../../orders/MultiStepOrderModal";
import { useUser } from "../../../../hooks/useUser";
import { useCommonParams } from "../../../../hooks/useCommonParams";
import { VideoSection } from "../../../../components/videoSection/VideoSection";
import Switcher from "../adminVideosV2/switcher";

type OutletContext = [unknown, unknown, unknown, (count: number) => void];

export function VideoTDCV2() {
    const [, , , setCount] = useOutletContext<OutletContext>();
    const [showOrderModal, setShowOrderModal] = useState(false);
    const { brand } = useUser();
    const brandId = Array.isArray(brand) ? brand[0]?.id : 0;

    const { searchParams, setSearchParams, searchText, setSearchText } = useCommonParams({});

    const videoId = useMemo(() => {
        const v = searchParams.get("video");
        return v ? parseInt(v, 10) || null : null;
    }, [searchParams]);

    const handleResetVideo = () => {
        setSearchParams((params) => {
            params.delete("video");
            params.delete("selectedTab");
            return params;
        });
    };

    const onCountChange = useCallback((count: number) => setCount(count), [setCount]);

    return (
        <>
            {videoId ? (
                <Box flexGrow={1}>
                    <SelectedVideoV2 videoId={videoId} onClose={handleResetVideo} type="file" refetch={() => {}} />
                </Box>
            ) : (
                <MainContainer>
                    <ListPageHeader
                        title="Videos"
                        searchValue={searchText}
                        onSearchChange={setSearchText}
                        searchPlaceholder="Search videos"
                        searchInputId="search-videos-tdc"
                        searchDebounceMs={300}
                    />
                    {/* Brands reach /videos/embeds ONLY through this control —
                        there is no Stories nav entry. Production rendered it via
                        FilterSelector, which the redesign replaced; Switcher
                        hides the Stories half for internal roles itself. */}
                    <Box className="mt-2">
                        <Switcher isStories={false} />
                    </Box>
                    <Box className="mt-2">
                        <VideoSection
                            brandId={brandId}
                            defaultView="list"
                            features={{ sort: true, viewToggle: true, filters: true, nonProject: "probe" }}
                            emptyTitle="No videos yet"
                            emptyBody="Videos appear here once a project reaches delivery. Start by requesting a quote."
                            emptyCta={{ label: "Request a quote", onClick: () => setShowOrderModal(true) }}
                            onCountChange={onCountChange}
                        />
                    </Box>
                </MainContainer>
            )}
            <MultiStepOrderModal open={showOrderModal} onClose={() => setShowOrderModal(false)} />
        </>
    );
}
